import store from '@/Store'
import { downloadConvertBase64Url } from '@/utils/Download'
import { formatFileForSendWidget } from '@/utils/utils'
import mime from 'mime'

const setupApp = store.state.SetupApp

const detalheDeclaracao = async (idDeclaracao, subTitulo, titulo) => {
  let payload = {
    idDeclaracao, subTitulo, titulo
  }
  const response = await setupApp.apiFuncionalidade.detalhe({
    payload: payload,
    loading: true,
    handlerErrorIgnore: [404]
  })
  return response.data
}

const acionaFuncionalidade = async (req) => {
  let base64 = ''
  const response = await setupApp.apiFuncionalidade[req.nomeIntegracao]({
    payload: req.integracao.payload,
    loading: true,
    handlerErrorIgnore: true
  })
  if (response.data.url && !response.data.base64) {
    base64 = await downloadConvertBase64Url({ url: response.data.url })
  } else {
    base64 = `data:application/pdf;base64,${response.data.base64}`
  }
  const arquivo = formatFileForSendWidget(base64)
  const data = {
    type: 'arquivo',
    message: `${req.data.tituloWidget}.${mime.getExtension(arquivo.mimeType)}`,
    file: arquivo.file
  }
  return { status: true, data, message: 'sucesso' }
}

export {
  detalheDeclaracao,
  acionaFuncionalidade
}
